<template>
  <div>
    <div class="main">   
      <img src="static/img/act/5/article/1/1.jpg"  />
      <img src="static/img/act/5/article/1/2.jpg"  />
      <img src="static/img/act/5/article/1/3.jpg"  />
      <img src="static/img/act/5/article/1/4.jpg"  />
      <div class="bottom"></div> 
    </div>  
  </div>
</template>

<script>   

  export default {
    name: 'Act5Article',
    components: {       
    },
    data() {
      return {   
      }
    },
    mounted() {      
     },
    created() {       
    this.setDocumentV2(
      "侗寨斗牛的狂野史，不看你就亏啦！",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/5/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '侗寨斗牛的狂野史，不看你就亏啦！', '点击', '文章页面','0','5']);  

    },
    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main{
    position: relative;
  }
  .main img{
    width: 100%;
    border: 0;
    vertical-align: middle
  }
  .bottom{
    height: 1.37rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/act/5/Article.vue